<template>
  <BaseModal
    v-model="isVisible"
    :width="width"
    title="Discard Encounter Notes"
    :title-logo="deleteIcon"
    :header-background-color="'#faeaea'"
    :header-text-color="'#d10000'"
    :show-close="true"
    description="Are you sure you want to discard this encounter notes? This action cannot be undone."
    dialog-type="error"
    @close="handleClose"
  >
    <template #footer>
      <div class="delete-modal-actions">
        <NewButton
          type="normal"
          color-type="red-stroke"
          @click="handleClose"
        >
          Cancel
        </NewButton>
        <NewButton
          type="normal"
          color-type="red"
          @click="handleConfirm"
        >
          Yes, discard encounter notes.
        </NewButton>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseModal from './BaseModal.vue';
import NewButton from '@/NewLibrary/Button.vue';
import { deleteEncounterNoteApi } from '@/api/encounterNotes.js';

const deleteIcon = require('@/assets/encounterNotes/delete_24px.svg');

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  noteId: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '640px',
  },
});

const emit = defineEmits(['update:modelValue', 'close', 'deleted']);

const isDeleting = ref(false);

const isVisible = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const handleClose = () => {
  emit('update:modelValue', false);
  emit('close');
};

const handleConfirm = async () => {
  if (!props.noteId || isDeleting.value) return;
  
  isDeleting.value = true;
  try {
    await deleteEncounterNoteApi(props.noteId);
    emit('update:modelValue', false);
    emit('deleted');
  } catch (error) {
    console.error('Failed to delete encounter note:', error);
  } finally {
    isDeleting.value = false;
  }
};
</script>

<style scoped>
.delete-modal-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
</style>

